var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar-icon-wrapper medium-screen right",class:{ active: _vm.openMenu && _vm.updateOpenMenu },attrs:{"id":"menu-btn"},on:{"click":_vm.toggleMenu}},[_c('div',{class:'bar-icon background-' + _vm.pageColor}),_c('div',{class:'bar-icon background-' + _vm.pageColor}),_c('div',{class:'bar-icon background-' + _vm.pageColor})])
}
var staticRenderFns = []

export { render, staticRenderFns }